import Markdown from "markdown-to-jsx";
import React from "react";
import { twMerge } from "tailwind-merge";
import { ContentMarkdownType } from "../../../types/blocks";

const BlockMarkdown = ({
  markdown,
  block_settings: { background_color, html_id } = {
    background_color: "bg-white dark:bg-secondary-900",
  },
}: Omit<ContentMarkdownType, "type">) => {
  return (
    <section className={twMerge(background_color, "scroll-mt-20")} id={html_id}>
      <div className="max-w-screen-xl px-4 py-8 mx-auto sm:py-16 lg:px-6">
        <div className="mx-auto prose dark:prose-invert">
          <Markdown>{markdown}</Markdown>
        </div>
      </div>
    </section>
  );
};
export default BlockMarkdown;
